import { BlogCardType, BlogReleaseType, BlogSubscribeType, BlogType } from "."

export const subscribeData: BlogSubscribeType = {
  title: "Subcribe to our newsletter",
  text: "Read the industry news, receive solutions to your problems, and find the ways to save money.",
  button_caption: "Subscribe",
}

export const releaseData: BlogReleaseType = {
  card_type: "Release",
  card_version: "v 1.003.a41",
  date: "June 28, 2022",
  card_speaker: "Md Kamaruzzaman",
  card_duration: "15 m",
  title: "Enhancing JVM monitoring with Prometheus on AWS",
  link: "",
}

export const blogData: BlogCardType[] = [
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
  {
    card_type: "Blog",
    date: "June 28, 2022",
    card_speaker: "Md Kamaruzzaman",
    card_duration: "15 m",
    title: "Enhancing JVM monitoring with Prometheus on AWS",
    link: "",
    text: `Virtual threads are introduced into the JDK under the auspices
    of Project Loom. They are aimed at enhancing the performance of
    concurrent applications while preserving/ some more text to
    complete four lines in the block`,
  },
]


export const mockBlogData: BlogType = {
  subscribeData: subscribeData,
  releaseData: releaseData,
  blogData: blogData
}